import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function usePatientPaMatches({
  documentKey,
  enabled,
}: {
  documentKey: string
  enabled: boolean
}) {
  return useQuery({
    ...apiClient.getDocumentPatientPaMatchesDocumentsKeyPatientPaMatchesGetOptions({
      path: { key: documentKey },
    }),
    enabled,
  })
}
